import { useEffect } from 'react';
import { Form } from 'antd';

import { UsersAutocomplete } from 'modules';
import { LabelWithTooltip } from 'components';

import { UserSearchType } from 'types/user';
import { FormValuesType, ISearchUserBaseFormProps } from './SearchUserBaseForm.types';

import './SearchUserBaseForm.styles.scss';

const SearchUserBaseForm = ({
  values,
  loading,
  size,
  autoFocus,
  allowClear,
  tooltip,
  label = 'form.label.username',
  placeholder = 'form.placeholder.searchAndSelectUser',
  onFinish,
  onClear,
  inputProps,
  className = '',
  ...props
}: ISearchUserBaseFormProps) => {
  const initialValues: FormValuesType = { username: values?.username || '' };

  const [form] = Form.useForm();

  const handleSelectUser = async (user: UserSearchType) => {
    if (user) {
      await onFinish(user);
    }
  };

  useEffect(() => {
    const username = values.username;

    if (username) {
      form.setFieldsValue({ username });
    }
  }, [form, values.username]);

  return (
    <Form
      form={form}
      initialValues={initialValues}
      layout="vertical"
      className={`np-search-user-base-form ${className}`}
      {...props}
    >
      <Form.Item
        label={label && tooltip ? <LabelWithTooltip label={label} tooltip={tooltip} /> : label}
        name="username"
      >
        <UsersAutocomplete
          fullUser
          size={size}
          autoFocus={autoFocus}
          allowClear={allowClear}
          disabled={loading}
          placeholder={placeholder}
          onSelect={handleSelectUser}
          onClear={onClear}
          inputProps={inputProps}
        />
      </Form.Item>
    </Form>
  );
};

export default SearchUserBaseForm;
